export function initParallax() {
    const parallaxImages = document.querySelectorAll('.parallax'); // Najdi všechny obrázky s třídou 'parallax'

    function parallaxEffect() {
        parallaxImages.forEach((image) => {
            if (image) {
                const speed = image.getAttribute('data-speed') ? parseFloat(image.getAttribute('data-speed')) : 1.0;
                const offset = -1 * window.scrollY * speed;

                image.style.transform = `translateY(${offset}px)`;
            }
        });

        // Další requestAnimationFrame pro další snímek
        requestAnimationFrame(parallaxEffect);
    }

    // Spuštění paralaxy při prvním načtení
    requestAnimationFrame(parallaxEffect);
}
